import React, { useEffect } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { LoginStatus } from '../../redux/slices/userSlice'
import { openModal } from '../../redux/slices/modalSlice'
import { ModalType } from '../../core/enums/Modals'

const PrivateRoutes: React.FC = () => {
	const { loggedIn } = useAppSelector((state) => state.user)
	const dispatch = useAppDispatch()
	const location = useLocation()
    
	useEffect(() => {
		if (loggedIn !== LoginStatus.LoggedIn && loggedIn!== LoginStatus.Unknown) {
			dispatch(openModal({ modalType: ModalType.Login, modalProps: { routing: location } }))
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loggedIn, dispatch])

	if (loggedIn !== LoginStatus.LoggedIn && loggedIn!==LoginStatus.Unknown) {
		return <Navigate to="/" />
	}

	return <Outlet />
}

export default PrivateRoutes
